import { render, staticRenderFns } from "./session_limits.vue?vue&type=template&id=6f17d946&"
import script from "./session_limits.vue?vue&type=script&lang=js&"
export * from "./session_limits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f17d946')) {
      api.createRecord('6f17d946', component.options)
    } else {
      api.reload('6f17d946', component.options)
    }
    module.hot.accept("./session_limits.vue?vue&type=template&id=6f17d946&", function () {
      api.rerender('6f17d946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/profile/session_limits.vue"
export default component.exports